import { useState, useEffect } from 'react'

import { useFormik, Form, FormikProvider } from 'formik'

import { usePutImportFieldsMutation } from '../slice'
import { useGetFieldsQuery } from '../../../services/fields/slice'

import MapField from './mapField'
import FieldDrawer from '../../../features/fields/components/fieldDrawer'

import Button from '@mui/material/Button'
import Box from '@mui/material/Box'

const contactFields = [
  { value: 'Name', key: 'Full Name' },
  { value: 'Title', key: 'Title' },
  { value: 'Department', key: 'Department' },
  { value: 'PhoneNumber', key: 'Phone' },
  { value: 'MobilePhone', key: 'Mobile Phone' },
  { value: 'Email', key: 'Email' },
  { value: 'Note', key: 'Note' },
]

const MapFields = ({ imported, saveFields, setSaveFields }) => {
  const [fieldValues, setFieldValues] = useState([])
  const [showDrawer, setShowDrawer] = useState(false)

  const { data: prospectFields, isLoading } = useGetFieldsQuery('prospects')
  const [putImportFields] = usePutImportFieldsMutation()

  const { fields } = imported

  const onAddClick = () => {
    setShowDrawer(true)
  }

  const onSubmit = async (values) => {
    await putImportFields({ importId: imported.id, payload: values })
  }

  const validate = (values) => {
    const errors = {}
    if (values) {
      Object.keys(values).forEach((key) => {
        if (!values[key]) {
          errors[key] = 'Must be mapped. Select Ignore to skip.'
        }
      })
    }
    return errors
  }

  const formik = useFormik({
    initialValues: fields.reduce((acc, field) => {
      acc[field.incomingColumn] = ''
      return acc
    }, {}),
    validate,
    onSubmit,
  })

  useEffect(() => {
    if (saveFields) {
      setSaveFields(false)
      formik.submitForm()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveFields])

  useEffect(() => {
    if (prospectFields) {
      const mappedProspectFields = prospectFields
        .map((field) => ({
          key: field.label,
          value: field.name,
        }))
        .sort((a, b) => a.key.localeCompare(b.key))
      const contact1Fields = contactFields.map((field) => ({
        key: `Contact 1 ${field.key}`,
        value: `contact1${field.value}`,
      }))
      const contact2Fields = contactFields.map((field) => ({
        key: `Contact 2 ${field.key}`,
        value: `contact2${field.value}`,
      }))
      const contact3Fields = contactFields.map((field) => ({
        key: `Contact 3 ${field.key}`,
        value: `contact3${field.value}`,
      }))
      const contact4Fields = contactFields.map((field) => ({
        key: `Contact 4 ${field.key}`,
        value: `contact4${field.value}`,
      }))
      const values = [
        { key: '-- Ignore --', value: 'ignore' },
        ...mappedProspectFields,
        ...contact1Fields,
        ...contact2Fields,
        ...contact3Fields,
        ...contact4Fields,
      ]
      setFieldValues(values)
      fields.forEach((field) => {
        if (field.mappedField) {
          formik.setFieldValue(field.incomingColumn, field.mappedField)
        }
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prospectFields])

  return (
    <>
      <Box margin={2} sx={{ display: 'flex', flexDirection: 'row' }}>
        {isLoading && <div>Loading...</div>}
        {fieldValues && (
          <FormikProvider value={formik}>
            <Form>
              Mapping fields:
              {prospectFields &&
                fields.map((field, index) => (
                  <Box key={`box${index}`} sx={{ display: 'flex', flexDirection: 'row' }}>
                    <MapField key={`map${index}`} importedField={field.incomingColumn} prospectFields={fieldValues} />
                    <Button
                      sx={{ whiteSpace: 'nowrap', ml: 2, alignSelf: 'center' }}
                      key={`button${index}`}
                      variant="outlined"
                      color="primary"
                      onClick={() => onAddClick()}
                    >
                      Add Field
                    </Button>
                  </Box>
                ))}
            </Form>
          </FormikProvider>
        )}
      </Box>
      <FieldDrawer showDrawer={showDrawer} setShowDrawer={setShowDrawer} fixedEntity={'prospects'} />
    </>
  )
}

export default MapFields
